import React from "react";
import { Box, Typography } from "@mui/material";
import { formatLocalDateTime } from "../../utils/dateTime";

export default function RejectionAudit({ item }) {
  const fields = [
    ["Stage at Exit", item.exit_stage || "Not recorded"], ["Outcome", item.outcome || "Rejected"],
    ["Reason", item.rejection_reason || item.rejectionReason], ["Decision By", item.decision_by],
    ["Additional Feedback", item.rejection_note || item.rejectionNote], ["Disposition", item.disposition],
    ["Rejected By", item.rejected_by_name || item.rejected_by || item.actor_name],
    ["Rejected At", item.rejected_at && formatLocalDateTime(item.rejected_at)],
    ["Revisit At", item.revisit_at && formatLocalDateTime(item.revisit_at)],
  ].filter(([, value]) => value);
  return <Box sx={{ mt: 1, p: 1, border: "1px solid #FECACA", borderRadius: 1.5, bgcolor: "#FFF7F7", overflowWrap: "anywhere" }}>
    {fields.map(([label, value]) => <Typography key={label} sx={{ fontSize: 12, lineHeight: 1.6, whiteSpace: "pre-wrap" }}><strong>{label}:</strong> {value}</Typography>)}
  </Box>;
}
